<template>

    <div class="app__container">

        <div class="contact__container">

            <app-header></app-header>

            <div class="intro" v-bind:style="{ backgroundImage: image_url() }">

                <div class="overlay">

                    <div class="wrapper">
                        <p class="subline">CAREER</p>
                        <h1 class="headline">CONTACT US</h1>

                        <p class="keywords">
                            Have and interesting idea in Your mind, feel free<br>
                            to contact us
                        </p>

                        <a class="anim_button" @click="scrollPageHeight()">
                            <p>SEE MORE INFO</p>
                            <div class="span_bg"></div>
                        </a>

                    </div>

                    <div class="bottom__bar" id="see_more">

                        <div class="text-wrap">
                            <p class="red_text">SEND</p>
                            <p class="regular_text">MESSAGE</p>
                            <p class="red_text second">00</p>
                        </div>

                    </div>

                </div>

            </div>

            <div class="content">

                <div class="mask-overlay"></div>

                <div class="mobile__headline">
                    <p class="red">CONTACT</p>
                    <p class="white">US</p>
                </div>

                <div class="informations">
                    <p class="subline">We'd love to hear from you</p>
                    <p class="title">Let's build something great together</p>

                    <p class="description">
                        Thank you for your interest in our company. Please fill out the form below - we will get back to you as soon as possible.
                    </p>

                    <div class="featured-img"></div>
                </div>

                <a class="to__contactform" href="#form">
                    <p>CONTACT US</p>
                    <div class="span_bg"></div>
                </a>

                <div class="contact__form" id="form">

                    <p class="subline">CONTACT FORM</p>
                    <p class="title">SEND US A MESSAGE</p>

                    <template v-if="submitted">
                        <div class="success__message">
                            <p class="message">Thank You for Your time!</p>
                        </div>
                    </template>
                    <template v-else>

                        <p class="desc-text">
                            Headquarters:
                        </p>

                        <div class="contact__inputs__description">

                            <div class="map">

                                <div id="map"></div>
                                
                                <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d5754.024641727512!2d18.4033247!3d43.8555733!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4758c8df25ac110b%3A0xb1cd13f8b38c755a!2sSCC%20-%20Sarajevo%20City%20Center!5e0!3m2!1sen!2sba!4v1680856537318!5m2!1sen!2sba" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->

                            </div>

                            <div class="form__inputs">

                                <div class="input__column">
                                    <label>NAME:</label>
                                    <div class="inputs">
                                        <div class="custominput firstname">
                                            <input v-bind:class="this.errors.first_name ? 'invalid' : ''" type="text" placeholder="First name" id="first_name" @keypress="dismissErrors"  v-model="first_name" required>
                                            <small>{{ this.errors.first_name ? this.errors.first_name[0] : ''}}</small>
                                        </div>
                                        <div class="custominput lastname">
                                            <input v-bind:class="this.errors.last_name ? 'invalid' : ''" type="text" placeholder="Last name" id="last_name" @keypress="dismissErrors"  v-model="last_name" required>
                                            <small>{{ this.errors.last_name ? this.errors.last_name[0] : ''}}</small>
                                        </div>
                                    </div>
                                </div>

                                <div class="input__column email">
                                    <label>E-MAIL ADDRESS:</label>
                                    <div class="custominput email">
                                        <input v-bind:class="this.errors.email ? 'invalid' : ''" type="email" placeholder="name@example.com" id="email" @keypress="dismissErrors" v-model="email" required/>
                                        <small>{{ this.errors.email ? this.errors.email[0] : ''}}</small>
                                    </div>
                                </div>

                                <div class="input__column subject">
                                    <label>SUBJECT:</label>
                                    <div class="custominput subject">
                                        <input v-bind:class="this.errors.subject ? 'invalid' : ''" type="text" placeholder="Name Your subject" id="subject" @keypress="dismissErrors" v-model="subject" required/>
                                        <small>{{ this.errors.subject ? this.errors.subject[0] : ''}}</small>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="contactmessage">
                            <p class="headline">WRITE US A MESSAGE:</p>

                            <textarea v-bind:class="this.errors.message ? 'invalid' : ''" placeholder="Your message:" id="message" @keypress="dismissErrors" v-model="message"></textarea>

                            <small>{{ this.errors.message ? this.errors.message[0] : ''}}</small>

                            <ReCaptcha ref="captcha"></ReCaptcha>

                            <template v-if="captcha_solved === false">
                                <div class="captcha-error"><p>Please complete the captcha challenge in order to continue.</p></div>
                            </template>

                            <div class="sendmessage" @click="submitForm()">
                                <p>SEND MESSAGE</p>
                                <div class="span_bg"></div>
                            </div>
                        </div>

                    </template>


                </div>

            </div>

            <app-footer></app-footer>

        </div>

    </div>

   
</template>
<script>
    export default {
        data(){
            return {
                first_name: null,
                last_name: null,
                email: null,
                subject: null,
                message: null,
                errors: [],
                submitted: false,
                captcha_solved: null,
            }
        },
        props: ['hero_image'],

        beforeMount(){
            let style = document.createElement('link');
            style.type = "text/css";
            style.rel = "stylesheet";
            style.href = 'https://unpkg.com/leaflet@1.9.3/dist/leaflet.css';
            style.integrity = 'sha256-kLaT2GOSpHechhsozzB+flnD+zUyjE2LlfWPgU04xyI=';
            style.crossOrigin = "";
            document.head.appendChild(style);

            let script = document.createElement('script');
            script.src="https://unpkg.com/leaflet@1.9.3/dist/leaflet.js";
            script.integrity = "sha256-WBkoXOwTeyKclOHuWtc+i2uENFpDZ9YPdf5Hf+D7ewM=";
            script.crossOrigin = "";
            document.head.appendChild(script);
        },

        mounted(){

            document.onreadystatechange = () => {
                if (document.readyState == "complete") {
                    var map = L.map('map').setView([43.85548, 18.40793], 16);

                    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        maxZoom: 19,
                        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    }).addTo(map);

                    // L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
                    //     attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
                    // }).addTo(map);

                    const mGreen = L.marker([43.85548, 18.40793]).addTo(map);
                    mGreen.bindPopup('<a target="_blank" href="https://www.google.com/maps/place/SCC+-+Sarajevo+City+Center/@43.855365,18.4085291,350m/data=!3m1!1e3!4m6!3m5!1s0x4758c8df25ac110b:0xb1cd13f8b38c755a!8m2!3d43.8553997!4d18.4081149!16s%2Fm%2F0b75y43" style="text-decoration: none;"><p style="font-family: DIN Next LT Pro Bold; font-size: 16px; line-height: 16px; text-align: center !important; color: #5C2C90; margin: 0;">GATE21<br>d.o.o. Sarajevo</p></a>').openPopup();
                }
            }

        },
        methods: {
            scrollPageHeight(){
                const height = window.innerHeight - document.getElementsByTagName('header')[0].clientHeight;
                window.scrollBy(0, height);
            },

            image_url(){
                return "url('" + this.hero_image.media_URL + "')"
            },

            submitForm(){
                this.captcha_solved = this.$refs.captcha.isCompleted();
                if(!this.captcha_solved) return;

                const data = {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    email: this.email,
                    subject: this.subject,
                    message: this.message
                }

                var main = this;

                axios.post('/contact/sendmessage', data).then((response) => {
                    // console.log(response)
                    if(response.status === 200){
                        this.errors = [];
                        this.submitted = true;
                    }
                }).catch(function (error){
                    // console.log(error.response);
                    if(error.response.status === 422){
                        if(error.response.data.errors){
                            main.errors = error.response.data.errors;
                        }
                    }
                })
            },

            dismissErrors(event){
                const element = event.target;

                if(element){
                    const element_id = element.id;

                    if(this.errors[element_id]){
                        delete this.errors[element_id];
                    }
                }

            }
        }
    }
</script>
<style lang="scss" scoped>
    $max-width: 932px;

    .app__container{
        width: 100%;
        height: 100vh;
        position: relative;
        z-index: 1;

        .contact__container{
            display: flex;
            flex-direction: column;

            .intro{
                position: relative;
                height: 100vh;

                // background: url('/images/contact/hero.webp');
                background-repeat: no-repeat;
                background-position: center -140px;
                background-size: cover;
                background-color: black;

                .overlay{
                    display: block;
                    width: 100%;
                    height: 100%;
                    position: relative;

                    background: rgba(92, 44, 144, 0.6);

                    .wrapper{
                        display: block;
                        position: absolute;
                        top: 57%; right: 50%;
                        transform: translate(50%, -50%);
                        // width: 976px;
                        width: 100%;
                        max-width: 1020px;
                        height: auto;

                        .subline{
                            font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            // font-weight: 700;
                            font-size: 50px;
                            line-height: 60px;
                            /* identical to box height */

                            text-align: center;

                            color: #ED1163;
                            margin: 0;
                            text-align: left;
                        }

                        .headline{
                            font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            font-weight: 700;
                            font-size: 175px;
                            line-height: 175px;
                            /* identical to box height */

                            color: #FFFFFF;
                            margin: 0;

                            margin-left: -5px;
                        }

                        .keywords{
                            font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            font-size: 22px;
                            line-height: 30px;
                            /* or 136% */

                            margin: 0;
                            margin-top: 22px;
                            text-align: center;
                            width: 100%;
                            max-width: 454px;
                            margin-left: auto;
                            margin-right: auto;

                            color: #FFFFFF;
                        }

                        a.anim_button{
                            display: block;
                            background: rgba(15, 15, 15, 0.3);
                            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                            width: 409px;
                            height: 50px;
                            margin-bottom: -9px;
                            cursor: pointer;
                            user-select: none;
                            position: relative;
                            overflow-y: hidden;
                            z-index: 4;
                            text-decoration: none;
                            margin-top: 93px;
                            margin-left: auto;
                            margin-right: auto;

                            p{
                                font-family: "DIN Next LT Pro Medium", Tahoma, Verdana, sans-serif;
                                font-style: normal;
                                // font-weight: 700;
                                font-size: 20px;
                                line-height: 54px;
                                text-align: center;
                                letter-spacing: 0.2em;
                                text-transform: uppercase;
                                margin: 0 auto;

                                color: #FFFFFF;
                                position: relative;
                                z-index: 4;
                            }

                            div.span_bg{
                                background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                                height: 100%;
                                width: 100%;
                                transition: all .3s ease-in-out;
                                margin-top: auto;
                                margin-bottom: 0;
                                opacity: 0;

                                position: absolute;
                                bottom: -50px;
                                z-index: 3;
                            }

                            &:hover{
                                div.span_bg{
                                    height: calc(100%);
                                    bottom: 0;
                                    opacity: 1;
                                }
                            }
                        }
                    }

                    .bottom__bar{
                        background: linear-gradient(360deg, #1A1A1A -0.25%, #222222 100%);
                        height: 64px;
                        width: 100%;
                        position: absolute;
                        bottom: 0;

                        border-top: 1px solid #ED1163;
                        border-bottom: 1px solid #ED1163;

                        .text-wrap{
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            position: relative;
                            margin-top: 20px;

                            .red_text{
                                font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                                font-style: normal;
                                font-size: 25px;
                                line-height: 25px;
                                /* or 100% */

                                color: #ED1163;
                                margin: 0;

                                &.second{
                                    margin-left: 24px;
                                }
                            }

                            .regular_text{
                                font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                                font-style: normal;
                                font-size: 25px;
                                line-height: 25px;
                                /* or 100% */

                                color: #ffffff;
                                margin: 0;
                                margin-left: 8px;
                            }
                        }

                        
                    }
                }
            }

            .content{
                display: flex;
                flex-direction: column;
                // background: linear-gradient(180deg, #212121 0%, #5C2C90 100%);
                background: linear-gradient(180deg, #2A1542 0%, #000000 100%);

                border-bottom: 1px solid #ED1163;
                position: relative;
                padding-bottom: 50px;


                .mask-overlay{
                    position: absolute;
                    width: 100%;
                    max-width: 1314px;
                    height: 1077px;
                    background: url('/images/contact/overlay.webp');
                    top: 0;
                    left: 50%;
                    transform: translate(-50%, 0%);
                    z-index: 0;
                }

                .mobile__headline{
                    display: none;
                    flex-direction: column;
                    border-bottom: 1px solid #ED1163;
                    margin-top: 5px;
                    margin-bottom: 10px;
                    z-index: 1;
                    width: calc(100% - 22px);
                    margin-left: auto;
                    margin-right: auto;

                    .red{
                        font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 14px;
                        line-height: 17px;
                        /* identical to box height */

                        color: #ED1163;
                        margin: 0;
                        margin-right: 11px;
                        margin-left: auto;
                    }

                    .white{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 700;
                        font-size: 16px;
                        line-height: 19px;

                        color: #FFFFFF;
                        margin: 0;
                        margin-right: 11px;
                        margin-left: auto;
                    }
                }

                .informations{
                    display: flex;
                    flex-direction: column;
                    margin-top: 80px;
                    width: $max-width;
                    margin-left: auto;
                    margin-right: auto;
                    z-index: 1;

                    .subline{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-size: 14px;
                        line-height: 17px;

                        color: #ED1163;
                        margin: 0;
                        text-transform: uppercase;
                    }

                    .title{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-size: 30px;
                        line-height: 36px;

                        margin: 0;

                        color: #FFFFFF;
                        text-transform: uppercase;
                    }

                    .description{

                        font-family: 'DIN Next LT Pro Ultralight', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-size: 16px;
                        line-height: 19px;
                        margin: 0;
                        margin-top: 30px;

                        color: #FFFFFF;
                    }

                    .featured-img{
                        display: block;
                        background: url('/images/contact/info.webp');
                        width: 100%;
                        max-width: 950px;
                        height: 400px;

                        margin-top: 70px;
                    }
                }

                .to__contactform{
                    display: block;
                    background: rgba(15, 15, 15, 0.3);
                    border: 1px solid #ED1163;
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                    width: 230px;
                    height: 60px;
                    cursor: pointer;
                    user-select: none;
                    position: relative;
                    overflow-y: hidden;
                    z-index: 4;
                    text-decoration: none;

                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 80px;

                    p{
                        font-family: "DIN Next LT Pro Medium", Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 20px;
                        line-height: 60px;
                        text-align: center;
                        letter-spacing: 0.2em;
                        text-transform: uppercase;
                        margin: 0 auto;

                        color: #FFFFFF;
                        position: relative;
                        z-index: 4;
                    }

                    div.span_bg{
                        background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                        height: 100%;
                        width: 100%;
                        transition: all .3s ease-in-out;
                        margin-top: auto;
                        margin-bottom: 0;
                        opacity: 0;

                        position: absolute;
                        bottom: -50px;
                        z-index: 3;
                    }

                    &:hover{
                        div.span_bg{
                            height: calc(100%);
                            bottom: 0;
                            opacity: 1;
                        }
                    }
                }

                .contact__form{
                    margin-top: 139px;
                    padding-top: 24px;

                    width: 100%;
                    max-width: 1464px;
                    margin-left: auto;
                    margin-right: auto;

                    background: #343434;
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

                    // padding: 70px 65px;

                    transition: all .3s ease;

                    z-index: 1;
                    .success__message{
                        margin-bottom: 64px;

                        .message{
                            font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            font-size: 30px;
                            line-height: 36px;
                            /* identical to box height */
                            text-align: center;

                            color: white;
                            margin: 0;
                            margin-top: 54px;

                            animation: appearText 2s;
                        }

                        @keyframes appearText {
                            from {opacity: 0;}
                            to {opacity: 1;}
                        }
                    }

                    .subline{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-size: 14px;
                        line-height: 17px;
                        /* identical to box height */
                        text-align: left;

                        color: #ED1163;
                        margin: 0;
                        margin-top: 75px;
                        margin-left: 65px;
                    }

                    .title{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-size: 30px;
                        line-height: 36px;
                        /* identical to box height */

                        text-align: left;

                        color: #FFFFFF;
                        margin: 0;
                        margin-left: 65px;
                    }

                    .desc-text{
                        font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 400;
                        font-size: 20px;
                        line-height: 24px;

                        color: #FFFFFF;
                        margin: 0;
                        margin-top: 32px;
                        margin-left: 65px;
                    }

                    .contact__inputs__description{
                        margin-top: 31px;
                        margin-left: 65px;

                        display: flex;
                        flex-direction: row;
                        // width: 100%;
                        width: calc(100% - 120px);
                        margin-left: auto;
                        margin-right: auto;
                        justify-content: flex-start;

                        .map{
                            width: 100%;
                            max-width: 604px;
                            margin-right: 100px;

                            .markerText{
                                font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                                font-style: normal;
                                // font-weight: 700;
                                font-size: 20px;
                                line-height: 16px;
                                /* or 80% */

                                text-align: center;

                                color: #5C2C90;
                            }

                            // overflow:hidden;
                            // padding-bottom: 26.5%;

                            // position:relative;

                            // height:0;

                            // iframe{
                            //     left:0;
                            //     top:0;
                            //     height:100%;
                            //     width:100%;
                            //     position:absolute;
                            // }

                            #map { 
                                width: 100%;
                                // height: 180px; 
                                height: 100%;
                                min-height: 200px;

                            }

                        }

                        .form__inputs{

                            display: flex;
                            flex-direction: column;
                            width: 100%;
                            max-width: 630px;

                            .input__column{
                                display: flex;
                                flex-direction: column;

                                &.email{
                                    margin-top: 14px;
                                }

                                &.subject{
                                    margin-top: 14px;
                                }

                                label{                            
                                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                                    font-style: normal;
                                    font-size: 20px;
                                    line-height: 24px;

                                    margin-bottom: 10px;

                                    color: #FFFFFF;
                                }

                                .inputs{
                                    display: flex;
                                    flex-direction: row;
                                }

                                .custominput{
                                    width: calc(100% - 32px);

                                    input{
                                        background: rgba(43, 43, 43, 0.75);
                                        // opacity: 0.75;

                                        border: 2px solid #ED1163;
                                        border-left-color: transparent;
                                        border-top-color: transparent;
                                        border-right-color: transparent;



                                        box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
                                        height: 60px;

                                        outline: none;

                                        min-width: 100%;
                                        padding: 0 16px;
                                        
                                        font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                                        font-style: normal;
                                        font-weight: 400;
                                        font-size: 16px;
                                        line-height: 19px;

                                        margin-bottom: 5px;

                                        color: #FFFFFF;

                                        &::placeholder{
                                            color: rgba(255, 255, 255, 0.5);
                                        }

                                        transition: all .3s ease;

                                        &:focus{
                                            border-left-color: #ED1163;
                                            border-right-color: #ED1163;
                                            border-top-color: #ED1163;
                                        }

                                        &.invalid{
                                            border: 2px solid red;
                                        }
                                    }
                                    
                                    small{
                                        font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                                        font-style: normal;
                                        // font-weight: 400;
                                        font-size: 16px;
                                        line-height: 19px;
                                        color: red;
                                    }

                                    &.lastname{
                                        margin-left: 60px;
                                    }

                                    &.firstname, &.lastname{
                                        max-width: 300px - 32px;
                                        width: 100%;
                                    }

                                    &.email, &.subject{
                                        max-width: 630px - 32px;
                                        width: 100%;
                                    }
                                    
                                }

                            }

                        }
                    }

                    .contactmessage{
                        display: flex;
                        flex-direction: column;
                        margin-top: 44px;
                        margin-left: auto;
                        margin-right: auto;

                        width: calc(100% - 120px);

                        .headline{
                            font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            font-weight: 700;
                            font-size: 20px;
                            line-height: 24px;
                            margin: 0;
                            margin-bottom: 10px;
                            color: #FFFFFF;
                        }

                        textarea{
                            background: rgba(43, 43, 43, 0.75);
                            border: 2px solid #ED1163;
                            border-left-color: transparent;
                            border-top-color: transparent;
                            border-right-color: transparent;
                            box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
                            min-height: 200px;
                            // width: 100%;

                            font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            // font-weight: 400;
                            font-size: 16px;
                            line-height: 19px;

                            color: #FFFFFF;

                            padding: 16px;

                            outline: none;

                            &::placeholder{
                                color: rgba(255, 255, 255, 0.5);
                            }

                            transition: all .3s ease;

                            &:focus{
                                border-left-color: #ED1163;
                                border-right-color: #ED1163;
                                border-top-color: #ED1163;
                            }

                            &.invalid{
                                border: 2px solid red;
                            }

                            margin-bottom: 24px;
                        }

                        small{
                            font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            // font-weight: 400;
                            font-size: 16px;
                            line-height: 19px;
                            color: red;

                            margin-bottom: 24px;
                        }

                        .sendmessage{
                            display: block;
                            background: rgba(15, 15, 15, 0.3);
                            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                            width: 100%;
                            max-width: 409px;
                            height: 50px;
                            margin-bottom: 113px;
                            cursor: pointer;
                            user-select: none;
                            position: relative;
                            overflow-y: hidden;
                            z-index: 4;
                            text-decoration: none;
                            // margin-top: 93px;
                            margin-top: 42px;
                            margin-left: auto;
                            margin-right: auto;

                            p{
                                font-family: "DIN Next LT Pro Medium", Tahoma, Verdana, sans-serif;
                                font-style: normal;
                                // font-weight: 700;
                                font-size: 20px;
                                line-height: 56px;
                                text-align: center;
                                letter-spacing: 0.2em;
                                text-transform: uppercase;
                                margin: 0 auto;

                                color: #FFFFFF;
                                position: relative;
                                z-index: 4;
                            }

                            div.span_bg{
                                background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                                height: 100%;
                                width: 100%;
                                transition: all .3s ease-in-out;
                                margin-top: auto;
                                margin-bottom: 0;
                                opacity: 0;

                                position: absolute;
                                bottom: -50px;
                                z-index: 3;
                            }

                            &:hover{
                                div.span_bg{
                                    height: calc(100%);
                                    bottom: 0;
                                    opacity: 1;
                                }
                            }
                        }
                    }
                }
            }

        }

    }

    .captcha-error{
        display: block;
        margin: 12px auto;

        p{  
            font-family: 'DIN Next LT Pro Regular';
            color: #FFF;
            font-size: 20px;
            line-height: 20px;
            margin: 0;
            margin-top: 12px;
        }
    }

    @media screen and (max-width: 1470px) {

        .app__container .contact__container .content .contact__form{
            max-width: 90%;
        }

    }

    @media screen and (max-width: 836px) {

        .app__container{

            .contact__container{
                
                .intro{
                    background-position: center;
                    
                    .overlay{


                        .wrapper{
                            width: 100%;

                            .subline{
                                font-size: 20px;
                                line-height: 24px;
                                text-align: center;
                                margin-bottom: 15px;
                            }

                            .headline{
                                font-size: 40px;
                                line-height: 40px;
                                text-align: center;
                            }

                            .keywords{
                                font-size: 16px;
                                line-height: 16px;
                            }

                            a.anim_button{
                                width: 100%;
                                max-width: 245px;
                                height: 35px;
                                
                                p{
                                    font-size: 12px;
                                    line-height: 40px;
                                }
                            }
                        }

                        .bottom__bar{
                            .text-wrap{
                                .red_text, .regular_text, .red_text.second{
                                    font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                                    font-size: 18px;
                                    line-height: 25px;
                                }   
                            }
                        }
                    }
                }

                .content{
                    background: black;

                    .mobile__headline{
                        display: flex;
                    }

                    .mask-overlay{
                        width: 100%;

                        background: url('/images/contact/mobile_overlay.webp');
                        background-position-x: -275px;
                        background-repeat: no-repeat;
                    }

                    .informations{
                        width: calc(100% - 22px);
                        margin-left: auto;
                        margin-right: auto;

                        .description{
                            line-height: 16px;
                        }

                        .featured-img{
                            width: 100%;
                            background-position: center;
                            background-size: cover;
                            background-repeat: no-repeat;
                            height: 180px;
                        }
                    }

                    .to__contactform{
                        background: rgba(0, 0, 0, 0.6);
                        border: 1px solid #ED1163;
                        width: calc(100% - 40px);
                        height: 31px;
                        margin-left: auto;
                        margin-right: auto;

                        p{
                            font-size: 12px;
                            line-height: 33px;
                        }
                    }

                    .contact__form{
                        flex-direction: column;
                        padding: 0;
                        width: calc(100% - 22px);
                        margin-left: auto;
                        margin-right: auto;
                        padding-top: 60px;

                        .success__message{

                            .message{
                                font-size: 22px;
                                line-height: 22px;
                            }
                        }

                        .subline, .title, .desc-text{
                            padding-left: 10px;
                            padding-right: 10px;
                            margin-left: 0;
                        }
                        .subline{
                            padding-top: 10px;
                            font-size: 12px;
                            line-height: 14px;
                            margin-top: 0;
                        }

                        .title{
                            font-size: 22px;
                            line-height: 26px;
                        }

                        .desc-text{
                            font-size: 14px;
                            line-height: 17px;
                        }
                        
                        .contact__inputs__description{
                            flex-direction: column;
                            padding: 0 10px;
                            width: initial;
                            margin-top: 47px;

                            .map{
                                margin-right: 0;
                                max-width: 100%;
                                margin-bottom: 24px;
                            }

                            .form__inputs{
                                max-width: 100%;

                                .input__column{
                                
                                    .inputs{
                                        flex-direction: column;

                                        .custominput{
                                            max-width: 100%;

                                            margin-bottom: 50px;

                                            input{
                                                min-width: initial;
                                                width: calc(100% - 32px);
                                            }

                                            &.lastname{
                                                margin-left: 0;
                                            }

                                            &.firstname, &.lastname{
                                                margin-bottom: 0;
                                            }
                                        }
                                    }


                                    &.email, &.subject{
                                        margin-top: 14px;

                                        .custominput{

                                            &.email, &.subject{
                                                max-width: initial;

                                                input{
                                                    min-width: initial;
                                                    max-width: initial;
                                                    width: calc(100% - 32px);
                                                }
                                                    
                                            }
                                        }
                                    }

                                }
                            }
                        }

                        .contactmessage{
                            width: calc(100% - 22px);
                            margin-left: auto;
                            margin-right: auto;
                            margin-top: 14px;
                            
                            textarea{
                                min-width: initial;
                                width: calc(100% - 32px);
                            }

                            .sendmessage{
                                background: rgba(0, 0, 0, 0.6);
                                border: 1px solid #ED1163;

                                height: 31px;
                                width: calc(100% - 20px);
                                margin-left: auto;
                                margin-right: auto;
                                margin-bottom: 42px;
                                margin-top: 42px;

                                p{
                                    font-size: 12px;
                                    line-height: 33px;
                                }
                            }
                        }
                    }
                }
            }

        }

    }
    

</style>